import { BaseButton } from 'iebt-zing-storybook'
import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { trans } from 'sharedKernel/i18n'
import { UserTerms } from 'components/UserTerms'
import { ICaixaEmployeeRegisterForm } from '../store'
import { postProvider, PostFormat } from 'sharedKernel/api'
import { createCaixaEmployeeRegisterRequest } from './behavior'
import { showToast } from 'components/toast'
import { ROUTES } from 'sharedKernel/constants'
import { useSmartNavigateLegacy as useNavigate } from 'components/SmartLink'
import { EcosystemTerms } from 'components/EcosystemTerms'

export interface CaixaEmployeeRegisterActionsProps {
  registerFormState: ICaixaEmployeeRegisterForm
  setRegisterFormState: React.Dispatch<React.SetStateAction<ICaixaEmployeeRegisterForm>>
  challengeId?: string
}

export const CaixaEmployeeRegisterActions = ({ 
  registerFormState, 
  setRegisterFormState,
  challengeId 
}: CaixaEmployeeRegisterActionsProps): JSX.Element => {
  const { mutate: registerCaixaEmployee } = postProvider()
  const navigate = useNavigate()

  const labels = {
    subscribe: trans('Cadastrar'),
    login: trans('Login'),
    alreadyHaveAccount: trans('Já tem cadastro? Faça o login.'),
    registerSuccess: trans('Cadastro realizado com sucesso!')
  }


  const handleSave = (): void => {
    const registerUrl = '/v1/system/caixa-employee'

    const registerPost: PostFormat = createCaixaEmployeeRegisterRequest(
      registerFormState.form,
      registerUrl
    )
    
    registerCaixaEmployee(registerPost, {
      onSuccess: (response) => {
        showToast('success', 'Cadastro realizado com sucesso! Faça login para acessar a plataforma.')
        setTimeout(() => {
          navigate(ROUTES.USER_AUTH.LOGIN)
        }, 2000) 
      },
      onError: (error) => {
        showToast('error', error.response?.data?.message || 'Erro no cadastro')
      }
    })
  }


  return (
    <Col>
      <Row className='p-0'>
        <EcosystemTerms
          checked={registerFormState?.acceptEcosystemTerms}
          onCheck={(event) => {
            setRegisterFormState(prev => ({
              ...prev,
              acceptEcosystemTerms: event.target.checked
            }))
          }}
        />
      </Row>
      <Row className='p-0'>
        <UserTerms
          userType="caixa_employee"
          checked={registerFormState?.acceptUserTerms}
          onCheck={(event) => {
            setRegisterFormState(prev => ({
              ...prev,
              acceptUserTerms: event.target.checked
            }))
          }}
        />
      </Row>
      <Row className='mt-4 p-0'>
        <BaseButton 
          onClick={() => handleSave()} 
          disabled={!registerFormState.isFormValid || !registerFormState.acceptUserTerms} 
          size="big" 
          btnContent={labels.subscribe} 
          variant="primary" 
        />
      </Row>
    </Col>
  )
}
